export default "__VITE_ASSET__baa02055__"